import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getOfficeHierarchy = async () => {
  return axios
    .get(`${api_base_url}/OfficeHierarchy/OfficeHierarchy`)
    .then((res) => {
      return res.data;
    });
};

export const getOfficeHierarchyByOfficeHierarchyID = async (
  officeHierarchyId
) => {
  let officeHierarchyData;
  await axios
    .get(`${api_base_url}/OfficeHierarchy/${officeHierarchyId}`)
    .then((res) => (officeHierarchyData = res.data[0]));
  return officeHierarchyData;
};

export const getOfficeHierarchyChart = async () => {
  const data = await axios.get(
    `${api_base_url}/OfficeHierarchy/OfficeHierarchyChart`
  );
  return data;
};
